import * as React from 'react';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';

export const MissingStatus: React.FC = () => {
  return (
    <div className="rounded px-2 py-1 flex items-center space-x-4 bg-red-50 text-red-900">
      <ReportProblemIcon className="text-[1.2rem]" />
      <h4>Missing</h4>
    </div>
  );
};
